import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UnidadModel } from '../../modulo-maestros/models/unidad';
import { Observable } from 'rxjs';
import { ServicioTipoModel } from '../../modulo-maestros/models/servicio-tipo';
import { ServicioModel } from '../../modulo-maestros/models/servicio';
//import { Iespecificacion } from '../../interfaces/especificacion';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetCombosService {

  constructor(private http: HttpClient) { }

  getUnidad(): Observable<UnidadModel[]> {
    console.log("Aqui");
    return this.http.get<UnidadModel[]>(`${environment.url_api}Unidad/GetAll`);
  }

  // getServiciosTipo(): Observable<ServicioTipoModel[]> {
  //   return this.http.get<ServicioTipoModel[]>(`${environment.url_api}ServicioTipo/GetAll`);
  // }

  // getServicio(): Observable<ServicioModel[]> {
  //   return this.http.get<ServicioModel[]>(`${environment.url_api}Servicio/GetAll`);
  // }

  // getEspecificacion(): Observable<Iespecificacion[]> {
  //   return this.http.get<Iespecificacion[]>(`${environment.url_api}EspecificacionTipo/GetAll`);
  // }
}
